import { useState, useEffect } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import { Box, Typography, CircularProgress } from "@mui/material";

// ✅ PDF Worker
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

const PdfViewer = ({ fileUrl }) => {
  const [numPages, setNumPages] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // 🔥 RESPONSIVE WIDTH STATE
  const [pageWidth, setPageWidth] = useState(900);

  useEffect(() => {

    const updateWidth = () => {

      // Mobile
      if (window.innerWidth < 600) {
        setPageWidth(window.innerWidth - 24);
      }

      // Tablet
      else if (window.innerWidth < 900) {
        setPageWidth(window.innerWidth - 48);
      }

      // Desktop
      else {
        setPageWidth(900);
      }
    };

    updateWidth();

    window.addEventListener("resize", updateWidth);

    return () => window.removeEventListener("resize", updateWidth);

  }, []);

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
    setLoading(false);
    setError(null);
  };

  const onDocumentLoadError = (err) => {
    console.error("PDF load error:", err);
    setLoading(false);
    setError("Failed to load PDF.");
  };

  if (!fileUrl) return null;

  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        overflowY: "auto",
        overflowX: "hidden",
        display: "flex",
        justifyContent: "center",
        px: { xs: 1, sm: 2 },
      }}
    >

      {loading && (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
            flexDirection: "column",
            gap: 2,
          }}
        >
          <CircularProgress />
          <Typography>Loading PDF...</Typography>
        </Box>
      )}

      {error && (
        <Typography color="error" sx={{ mt: 4 }}>
          {error}
        </Typography>
      )}

      <Document
        file={fileUrl}
        onLoadSuccess={onDocumentLoadSuccess}
        onLoadError={onDocumentLoadError}
        loading=""
      >
        {!loading &&
          !error &&
          Array.from(new Array(numPages), (_, index) => (
            <Box
              key={index}
              sx={{
                mb: 3,
                background: "#fff",
                display: "flex",
                justifyContent: "center",
                width: "100%",
              }}
            >
              <Page
                pageNumber={index + 1}
                width={pageWidth}
                renderTextLayer={false}
                renderAnnotationLayer={false}
              />
            </Box>
          ))}
      </Document>
    </Box>
  );
};

export default PdfViewer;

// import { useState } from "react";
// import { Document, Page, pdfjs } from "react-pdf";
// import { Box, Typography, CircularProgress } from "@mui/material";

// // ✅ PERFECT WORKER FOR CRA + React 18
// pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

// const PdfViewer = ({ fileUrl }) => {
//   const [numPages, setNumPages] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   const onDocumentLoadSuccess = ({ numPages }) => {
//     setNumPages(numPages);
//     setLoading(false);
//     setError(null);
//   };

//   const onDocumentLoadError = (err) => {
//     console.error("PDF load error:", err);
//     setLoading(false);
//     setError("Failed to load PDF.");
//   };

//   if (!fileUrl) return null;

//   return (
//     <Box
//       sx={{
//         width: "100%",
//         height: "100%",
//         overflow: "auto",
//         // backgroundColor: "#f3f4f6",
//         display: "flex",
//         justifyContent: "center",
//       }}
//     >
//       {loading && (
//         <Box
//           sx={{
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             height: "100%",
//             flexDirection: "column",
//             gap: 2,
//           }}
//         >
//           <CircularProgress />
//           <Typography>Loading PDF...</Typography>
//         </Box>
//       )}

//       {error && (
//         <Typography color="error" sx={{ mt: 4 }}>
//           {error}
//         </Typography>
//       )}

//       <Document
//         file={fileUrl}
//         onLoadSuccess={onDocumentLoadSuccess}
//         onLoadError={onDocumentLoadError}
//         loading=""
//       >
//         {!loading &&
//           !error &&
//           Array.from(new Array(numPages), (_, index) => (
//             <Box
//               key={index}
//               sx={{
//                 mb: 3,
//                 boxShadow: 3,
//                 background: "#fff",
//               }}
//             >
//               <Page
//                 pageNumber={index + 1}
//                 width={1000} // 🔥 FULL WIDTH = NO SIDE BLACK BORDER
//                 renderTextLayer={false}
//                 renderAnnotationLayer={false}
//               />
//             </Box>
//           ))}
//       </Document>
//     </Box>
//   );
// };

// export default PdfViewer;